import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminSuppliesAddPage } from './admin-supplies-add';

@NgModule({
  declarations: [
    AdminSuppliesAddPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminSuppliesAddPage),
  ],
})
export class AdminSuppliesAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-supplies-add/admin-supplies-add.module.ts